import React from 'react';
import './Dropdown.scss';

const Dropdown = ({ options, onItemClick, selected, defaultTitle, onBackdropClick, width, btnStyle, value, prefix, disabled, id }) => {
    const [ isShow, setIsShow ] = React.useState(false)
    const [ selectedItem, setSelectedItem ] = React.useState()

    const toggleDrop = () => {
        setIsShow(!isShow)
    }

    return (
        <div className="dropdown" onClick={() => typeof onBackdropClick !== 'undefined' ? onBackdropClick() : null } id={id}>
            <button onClick={() => toggleDrop()} className={`dropbtn ${selected ? 'dropbtn-selected' : ''}`} style={{ width : width, ...btnStyle, color : disabled ? '#9f9f9f' : '#3f3f3f' }} disabled={disabled}>
                <div className='row between'>
                {value}{prefix}
                <img src={require('../../aseets/icons/dropdown.svg').default} style={{ width : 24, height : 24 }}/>
                </div>
            </button>
            <div id="myDropdown" className={`dropdown-content ${isShow ? 'show' : ''}`}>
                {
                    options.map((data,i) => {
                        return(
                            <button className={`dropdown-item ${selected && selectedItem === data.value ? 'item-selected' : ''}`} style={{ width : width - 16 }} key={data.key} onClick={() => {onItemClick(data.value);setSelectedItem(data.value);toggleDrop(false)} }>
                                {data.key}
                            </button>
                        )
                    })
                }
            </div>
        </div>
    )
}

export default Dropdown;